import {fromJS} from 'immutable';
import * as actions from './actions';
import * as m from './model';

export const INITIAL_STATE = fromJS({
    loading: true,
    user: new m.User(),
    venues: {},
    events: {},
    entries: {},
});

export default function reducer(state = INITIAL_STATE, action) {
    if (action.type in actions) {
        return actions[action.type](state, action);
    }

    if (action.type.match(/^@@redux\//) || action.type === '@@INIT') {
        // Choosing to ignore these quietly for now
        return state;
    }

    console.error("Unknown action type: ", action.type);
    return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducer.js
 **/